// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Drawer } from '../../../drawer';
import { LangDrawerContainer } from './style';
import { warningIconBase64 } from '../../../../assets/base64/warning-icon';
import { useTranslation } from 'react-i18next';
import { OptionCard } from '../option-card';
export const LangDrawerComponent = ({ isOpen, onClose, language, setLanguage, }) => {
    const [selectedLang, setSelectedLang] = useState(language);
    const { t } = useTranslation('drawerChangeLangue');
    useEffect(() => {
        setSelectedLang(language);
    }, [isOpen]);
    const languages = [
        { value: 'pt-BR', label: 'Português (BR)', country: 'BR' },
        { value: 'es-ES', label: 'Español', country: 'ES' },
        { value: 'en-US', label: 'English', country: 'GB' },
    ];
    return ReactDOM.createPortal(React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, title: t('drawerChangeLangue:title'), cancelButton: {
            text: t('drawerChangeLangue:btnCancel'),
        }, confirmButton: {
            text: t('drawerChangeLangue:btnConfirm'),
            onClick: () => setLanguage(selectedLang),
            disabled: language === selectedLang,
        } },
        React.createElement(LangDrawerContainer, null,
            React.createElement("p", { className: "drawer-lang_description" }, t('drawerChangeLangue:description')),
            React.createElement("section", { className: "drawer-lang_body" }, languages.map(({ value, label, country }) => (React.createElement(OptionCard, { key: value, name: "language", value: value, country: country, title: label, checked: value === selectedLang, onChange: setSelectedLang })))),
            selectedLang !== 'pt-BR' && (React.createElement("section", { className: "drawer-lang_footer" },
                React.createElement("img", { alt: "Warning", title: "Warning", src: warningIconBase64 }),
                React.createElement("div", null,
                    React.createElement("p", { className: "drawer-lang_footer-title" }, t('drawerChangeLangue:alertTitle')),
                    React.createElement("p", null, t('drawerChangeLangue:alertDescription'))))))), document.getElementById('root-app_side_content'));
};
//# sourceMappingURL=component.js.map